/** STOMP destination builders — must match backend RealtimeTopics.java */
export const realtimeChannels = {
  userNotifications: '/user/queue/notifications',
  userApprovals: '/user/queue/approvals',

  orgDashboard: (orgId: number) => `/topic/org.${orgId}.dashboard`,

  storePos: (orgId: number, storeId: number) =>
    `/topic/org.${orgId}.store.${storeId}.pos`,

  storeInventory: (orgId: number, storeId: number) =>
    `/topic/org.${orgId}.store.${storeId}.inventory`,

  orgAttendance: (orgId: number) => `/topic/org.${orgId}.hr.attendance`,

  orgSocialInbox: (orgId: number) => `/topic/org.${orgId}.social.inbox`,

  orgSocialComments: (orgId: number) => `/topic/org.${orgId}.social.comments`,

  orgSocialAnalytics: (orgId: number) => `/topic/org.${orgId}.social.analytics`,

  orgSocialWhatsAppAnalytics: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.analytics`,

  orgSocialWhatsAppReports: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.reports`,

  orgSocialContent: (orgId: number) => `/topic/org.${orgId}.social.content`,

  orgSocialMedia: (orgId: number) => `/topic/org.${orgId}.social.media`,

  orgSocialStorage: (orgId: number) => `/topic/org.${orgId}.social.storage`,

  orgSocialContactImports: (orgId: number) => `/topic/org.${orgId}.social.contact-imports`,

  orgSocialWhatsAppTemplates: (orgId: number) => `/topic/org.${orgId}.social.whatsapp.templates`,

  orgSocialWhatsAppTemplateSends: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.template-sends`,

  orgSocialWhatsAppGroups: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.groups`,

  orgSocialWhatsAppCampaigns: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.campaigns`,

  orgSocialWhatsAppSchedules: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.schedules`,

  orgSocialWhatsAppBulkQueues: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.bulk-queues`,

  orgSocialWhatsAppSync: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.sync`,

  orgSocialWhatsAppWebhooks: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.webhooks`,

  orgSocialWhatsAppSettings: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.settings`,

  orgSocialWhatsAppAutomations: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.automations`,

  orgSocialWhatsAppInbox: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.inbox`,

  orgSocialWhatsAppAudit: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.audit`,

  orgSocialWhatsAppIntegrations: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.integrations`,

  orgSocialWhatsAppAi: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.ai`,

  orgSocialWhatsAppKb: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.kb`,

  orgSocialWhatsAppSurveys: (orgId: number) =>
    `/topic/org.${orgId}.social.whatsapp.surveys`,

  orgLeadAssignments: (orgId: number) => `/topic/org.${orgId}.crm.lead-assignments`,

  posDisplay: (token: string) => `/topic/display.${token}`,
} as const;
